module.exports = __webpack_public_path__ + "media/img/help_center/Institution_Message_03-26bda5669f038fd5ea7e5be2c7627a88.jpg";